export default "//cdn.scentbird.com/assets/frontbird-site/images/leather_37a7ea.jpg";